(function () {
    'use strict';

    angular
        .module('adminReferenceDataControllers')
        .controller('AdminReferenceDataController', Controller);

    Controller.$inject = ['$scope', '$interval', 'topBarService', 'itemTypes', 'adminReferenceDataService', 'LookupAttributeValueViewModelFactory'];

    function Controller($scope, $interval, topBarService, itemTypes, adminReferenceDataService, LookupAttributeValueViewModelFactory) {

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Manage Reference Data', 'fa fa-map-signs');

        $scope.itemTypes = itemTypes;

        $scope.lookupAttributes;
        $scope.lookupAttributeValues;

        // Select ItemType
        $scope.selectItemType = function (itemType) {

            adminReferenceDataService
                .getLookupAttributeValues(itemType.ItemTypeID)
                .then(function (lookupAttributes) {
                    delete lookupAttributes._GOV;
                    $scope.lookupAttributes = lookupAttributes;
                    $scope.selectedItemType = itemType;
                    clearLookupAttributesBox();
                });
        }

        // Select LookupAttribute
        $scope.selectLookupAttribute = function (lookupAttribute) {

            var oldLookupAttribute = $scope.selectedLookupAttribute;
            $scope.selectedLookupAttribute = lookupAttribute;

            if (!_.isUndefined(oldLookupAttribute)) {
                oldLookupAttribute.LookupAttributeValues = _.map($scope.lookupAttributeValues,
                                                                function (value, index, collection) {
                                                                    return value.model;
                                                                });
            }

            if (_.isUndefined(lookupAttribute.LookupAttributeValues)) {
                $scope.lookupAttributeValues = [];
                return;
            }
            
            $scope.lookupAttributeValues = _.map(lookupAttribute.LookupAttributeValues,
                                                function (value, index, collection) {
                                                    return LookupAttributeValueViewModelFactory.CreateViewModel(value);
                                                });
        }

        // Get Selected ItemType TitleEN
        $scope.getSelectedItemTypeTitle = function () {
            if (_.isUndefined($scope.selectedItemType)) {
                return null;
            }

            return $scope.selectedItemType.TitleEN;
        };

        // CreateOrUpdate
        $scope.addLookupAttributeValue = function () {

            if (_.isUndefined($scope.lookupAttributeValues)) {
                return;
            }

            var genericValue = generateEmptyLookupAttributeValue();

            var vm = LookupAttributeValueViewModelFactory
                            .CreateViewModel(genericValue)

            $scope.lookupAttributeValues.push(vm);
        };

        // Delete
        $scope.deleteLookupAttributeValue = function (value) {

            value.Delete()
                .then(function (data) {
                    $scope.lookupAttributeValues = _.reject($scope.lookupAttributeValues,
                    function (o) { return o === value; });
                });
        };

        // Cancel
        $scope.cancelLookupAttributeValue = function (value) {

            value.Cancel()
                .then(function () {
                    if (_.isUndefined(value.model.LookupAttributeValueID)) {
                        $scope.lookupAttributeValues = _.reject($scope.lookupAttributeValues,
                                                                function (o) { return o === value; });
                    }
                });
        };

        var clearLookupAttributesBox = function () {

            if(!_.isUndefined($scope.selectedLookupAttribute)) {
                $scope.selectedLookupAttribute = undefined;
            }

            $scope.lookupAttributeValues = undefined;
        };

        var generateEmptyLookupAttributeValue = function () {
            var entity = {};

            entity.LookupAttributeIsUserDefined = true;
            entity.Value = "";
            entity.TitleEN = "";

            return entity;
        };

        var intervalPromise;

        $scope.$on('$destroy', function () {
            if (intervalPromise) {
                $interval.cancel(intervalPromise);
            }
        });
    }
})();